<div class="row">
  <div class="col-sm-12">
    <div class="box box-solid">
      <div class="box-header with-border">
        <h3 class="box-title" translate>
          Process
          <small>
          </small>
        </h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-default btn-sm" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="box-body">
        <div class=row>
          <div class="col-sm-12">
            <label data-toggle="tooltip" style="cursor: pointer;">
              <a class="btn btn-primary" translate>
                <i class="fa fa-cloud-upload"></i>&nbsp;
                Import Data
              </a>
              <input type="file" style="display: none;"  id="btnFile" />
            </label>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="dlgConfirm">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" translate>Confirm?</h4>
      </div>
      <div class="modal-body textcenter">
        <p class="input-text" id="lblData" translate>Import Data</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary pull-left" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="Upload()" translate>OK</button>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/member/member-import/member-import.component.html